import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CategoryProductsPage from "./pages/CategoryProductsPage";
import Navbar from "./components/Navbar";
import "./App.css";
import ContactUsPage from "./pages/ContactUsPage";
import LeadsPage from "./pages/LeadsPage";
import AboutUs from "./pages/AboutUs";
import Footer from "./components/footer/Footer";
import CategoryPage from "./pages/CategoryPage";
import FAQsPage from "./pages/FAQsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import AchieversPage from "./pages/AchieversPage";

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/category/:categoryName" element={<CategoryPage />} />
          <Route
            path="/category/:categoryName/:subCategoryName"
            element={<CategoryProductsPage />}
          />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route
            path="/category/:categoryName"
            element={<CategoryProductsPage />}
          />
          <Route
            path="/category/:categoryName/:subCategoryName"
            element={<CategoryProductsPage />}
          />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/achievers" element={<AchieversPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
